import { updateEntitySchemaForLabels, updateOdataOptionsForLabels, initialize as initializeLabels } from '../util/update-label-property-for-filter';
import { initialize as initializeDeliveryStatus } from '../util/update-delivery-status-property-for-filter';
import { initialize as initializePop, appendPeriodOverPeriodProperties } from '../util/update-pop-property-for-filter';
import { initialize as initializeAuctionInsight } from '../util/update-auction-insight-property-for-filter';
import { initialize as initializeExperiment, updateOdataOptionsForExperiment } from '../util/update-experiment-property-for-filter';
import { initialize as initializeAdsByBing } from '../util/update-adsbybing-property-for-filter';
import { updateOdataOptionsForMultiplied } from '../util/update-mutiplied-property-for-filter';

export class BaseSchemaProcessor {
  constructor(options) {
    initializeDeliveryStatus(options);
    initializeLabels(options);
    initializePop(options);
    initializeAuctionInsight(options);
    initializeExperiment(options);
    initializeAdsByBing(options);

    this.i18n = options.i18n;
    this.Permissions = options.globalConfig.get('Permissions');
    this.isForVNext = options.isForVNext;
    this.passedInI18n = options.passedInI18n;
    this.isAccountLabelsEnabled =
      this.Permissions && this.Permissions.IsAccountLabelsEnabled;
  }

  updateOdataOptions(odataOptions) {
    // For labels, as it is lambda expression, it need specific mapping from value to odata url
    updateOdataOptionsForLabels(odataOptions, this.isAccountLabelsEnabled);
    updateOdataOptionsForExperiment(odataOptions);
    updateOdataOptionsForMultiplied(odataOptions);

    return odataOptions;
  }

  updateEntitySchemaForFeatures(entitySchema) {
    updateEntitySchemaForLabels(entitySchema, this.isAccountLabelsEnabled);
    appendPeriodOverPeriodProperties(entitySchema);
    return entitySchema;
  }
}
